import { Button, Card, CardContent, CardActions } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import InfoIcon from "@mui/icons-material/Info";


function MyApplication() {
const navigate = useNavigate();


return (
<div className="min-h-screen w-full flex justify-center items-center bg-gradient-to-br from-gray-100 to-gray-200 p-4">
<Card className="w-full max-w-md rounded-2xl shadow-2xl bg-white/80 backdrop-blur-md border border-gray-200">
<CardContent className="flex flex-col items-center text-center p-6 sm:p-8">
<h1 className="text-3xl sm:text-4xl font-extrabold text-gray-800 tracking-wide mb-2">
My Application
</h1>
<p className="text-gray-600 font-medium text-sm sm:text-base">
Check your Application Status
</p>
</CardContent>


<CardActions className="flex justify-center pb-6">
<Button
onClick={() => navigate("/application/my_application_details")}
variant="contained"
size="large"
className="!bg-blue-600 hover:!bg-blue-700 !text-white !px-6 !py-3 rounded-xl shadow-lg transition-all duration-300 flex items-center gap-2"
startIcon={<InfoIcon />}
>
View Details
</Button>
</CardActions>
</Card>
</div>
);
}


export default MyApplication;